var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M7.12967 6H12.7171V7.04056L10.0413 9.35663C10.1768 9.33987 10.3183 9.33427 10.4479 9.33427C11.8566 9.33427 13 10.1063 13 11.5329C13 12.9483 11.8625 14 10.0707 14C8.52063 14 7.36542 13.2 7 11.9077L8.167 11.5664C8.36739 12.3888 9.05108 12.9538 10.0825 12.9538C11.1022 12.9538 11.7918 12.4056 11.7918 11.5441C11.7918 10.7329 11.1906 10.2909 10.1886 10.2909C9.74656 10.2909 9.27505 10.3748 8.98625 10.4587L8.37918 9.55243L11.1729 7.05734H7.12967V6Z",
            fill: "#666666",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }